import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import Utils from '@/utils';
import sentGAEvent from '@/ga';
import moment from 'moment';
import actions from '@/redux/action';
import { withTranslation } from 'react-i18next';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';
import AddFileByDragFunction from './children/AddFileByUrlFunction';
import TipsModal from '../../../common/tipModal/TipsModal';

class AddFileByUrl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      fetchUrl: '',
      visible: false,
      uploadXHR: null,
      warningInfo: false,
      warningInfoText: '',
      warningInfoTitle: '',
      warningInfoObj: {},
      fileObj: {},
    };
  }

  parseUrl = async (e) => {
    e.stopPropagation();
    const url = e.target.value;
    if (!url || this.state.visible) {
      return false;
    }
    if (this.props.work === 'togif') {
      sentGAEvent({
        category: 'ToGif',
        action: 'GifURL',
      });
    } else if (this.props.work === 'convert') {
      sentGAEvent({
        category: 'Convert',
        action: 'ConvertURL',
      });
    } else if (this.props.work === 'audioExtractor') {
      sentGAEvent({
        category: 'audio_extractor_add_files',
        action: 'audio_extractor_url_content',
        label: url,
      });
    } else if (this.props.work === 'audioCut') {
      sentGAEvent({
        category: 'audio_cut_add_files',
        action: 'audio_cut_url_content',
        label: url,
      });
      sentGAEvent({
        category: 'audio_cut_add_files',
        action: 'audio_cut_add_files',
        label: '1_url',
      });
    } else if (this.props.work === 'audioVolume') {
      sentGAEvent({
        category: 'audio_volume_add_files',
        action: 'audio_volume_url_content',
        label: url,
      });
      sentGAEvent({
        category: 'audio_volume_add_files',
        action: 'audio_volume_add_files',
        label: '1_url',
      });
    } else if (this.props.work === 'audioSpeed') {
      sentGAEvent({
        category: 'audio_speed_add_files',
        action: 'audio_speed_url_content',
        label: url,
      });
      sentGAEvent({
        category: 'audio_speed_add_files',
        action: 'audio_speed_add_files',
        label: '1_url',
      });
    }
    let urlResponse;
    try {
      this.setState({ visible: true, fetchUrl: url, clickSample: false });
      urlResponse = await this.requestParseUrl(url);
    } catch (error) {
      this.setState({ visible: false });
      if (error !== 'cancel') {
        message.warning(
          this.props.t('Sorry, error occurs when analyzing the URL.')
        );
        if (this.props.work === 'audioExtractor') {
          sentGAEvent({
            category: 'audio_extractor_add_files',
            action: 'audio_extractor_url_fail',
          });
        } else {
          sentGAEvent({
            category: 'Upload',
            action: 'URLFail',
            label: error,
          });
        }
      }
      return false;
    }
    this.setState({ uploadXHR: null });
    if (urlResponse.code === 200) {
      if (urlResponse.data.result.number) {
        // get videofileurl
        const fileResponseNumber = urlResponse.data.result.number;
        let progressResponse;
        try {
          progressResponse = await Utils.getProgress(fileResponseNumber, true);
        } catch (error) {
          if (error !== 'cancel') {
            message.warning(
              this.props.t('Sorry, error occurs when analyzing the URL.')
            );
          }
          this.setState({ visible: false });
          if (this.props.work === 'audioExtractor') {
            sentGAEvent({
              category: 'audio_extractor_add_files',
              action: 'audio_extractor_url_fail',
            });
          } else {
            sentGAEvent({
              category: 'Upload',
              action: 'URLFail',
              label: error,
            });
          }

          return false;
        }
        const videofileurl = urlResponse.data.response_file[0];
        const duration = moment('00:00:00', 'mm:ss:SS')
          .add(parseFloat(progressResponse.info[0].duration), 'seconds')
          .format('mm:ss:SS')
          .replace(/:([^:]*)$/, '.$1');
        const fps = progressResponse.info[0].fps;
        const size = parseInt(progressResponse.info[0].size);
        if (this.props.work === 'audioExtractor') {
          sentGAEvent({
            category: 'audio_extractor_add_files',
            action: 'audio_extractor_add_files',
            label:
              'mp4_' +
              (size / 1024).toFixed(2) +
              'kb' +
              '_' +
              Utils.changeTimeToGAString(progressResponse.info[0].duration),
          });
        } else if (this.props.work === 'audioCut') {
          sentGAEvent({
            category: 'audio_cut_add_files',
            action: 'audio_cut_add_files_click',
            label:
              'mp4_' +
              (size / 1024).toFixed(2) +
              'kb' +
              '_' +
              Utils.changeTimeToGAString(progressResponse.info[0].duration),
          });
        } else if (this.props.work === 'audioVolume') {
          sentGAEvent({
            category: 'audio_volume_add_files',
            action: 'audio_volume_add_files_click',
            label:
              'mp4_' +
              (size / 1024).toFixed(2) +
              'kb' +
              '_' +
              Utils.changeTimeToGAString(progressResponse.info[0].duration),
          });
        } else if (this.props.work === 'audioSpeed') {
          sentGAEvent({
            category: 'audio_speed_add_files',
            action: 'audio_speed_add_files_click',
            label:
              'url_mp4_' +
              Utils.changeTimeToGAString(progressResponse.info[0].duration) +
              '_' +
              (size / 1024).toFixed(2) +
              'kb',
          });
        }

        // size > 100MB
        if ((size / 1024 / 1024).toFixed(2) > 100) {
          this.setState({
            warningInfo: true,
            warningInfoText:
              'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ',
            warningInfoLinkText: 'download the video',
            warningInfoText2: 'and then use HitPaw Toolkit to proceed.',
            warningInfoObj: {
              type: 'urlSize',
              duration: size,
            },
            fileObj: {
              videofileurl: videofileurl,
              name: videofileurl.split('/')[videofileurl.split('/').length - 1],
            },
          });
          sentGAEvent({
            category: 'Upload',
            action: 'URLSizePopup',
            label: `${(size / 1024 / 1024).toFixed(2)}_${
              urlResponse.data.response_hostname[0]
            }`,
          });
          this.setState({ visible: false });
          return false;
        }
        let wh;
        try {
          wh = progressResponse.info[0].wh.match(/^\d+x\d+/)[0];
        } catch (e) {
          wh = '0x0';
        }
        // get screenshots
        const d = Utils.getSeconds(duration);
        if (d < 1) {
          this.setState({
            warningInfo: true,
            warningInfoText:
              'The minimum time length is 1s! Get HitPaw Toolkit for more features.',
            warningInfoObj: {
              type: 'duration',
              duration: d,
            },
          });
          this.setState({ visible: false });
          return false;
        }
        const screenshots = progressResponse.thumbnail[0].img;
        const thumbnail = screenshots[0];
        const files = [...this.props.files];
        const arrItem = {
          name: 'HitPaw.mp4',
          guid: new Date().getTime(),
          duration: duration,
          size: size,
          thumbnail: thumbnail,
          status: 'ready',
          videofileurl: videofileurl,
          screenshots: screenshots,
          mark: false,
          wh: wh,
          fps: fps,
          uploadStatus: true,
        };
        if (this.props.work === 'convert') {
          arrItem.fileObj = { type: 'video/mp4' };
          arrItem.type = 'video/mp4';
          arrItem.convertType = 'mp4';
          arrItem.convertFileType = 'video';
          arrItem.fileType = 'video';
        }
        files.push(arrItem);
        if (this.props.addFileCallBack) {
          this.props.addFileCallBack(arrItem);
        } else {
          this.props.onCurrFileChange(arrItem);
        }
        this.props.onFilesChange(files);
        this.setState({ visible: false });
        this.clearUrl();
        sentGAEvent({
          category: 'Upload',
          action: 'URLSuccess',
          label: `${(size / 1024 / 1024).toFixed(2)}_${
            urlResponse.data.response_hostname
          }`,
        });
        message.destroy();
      }
    } else {
      console.log(urlResponse);
      if (urlResponse.code === 401) {
        Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
        let hostName = window.location.hostname;
        Cookies.remove('access_token', {
          domain: hostName.substring(
            window.location.hostname.indexOf('.'),
            hostName.length
          ),
        });
        Cookies.remove('access_token_expires_in', {
          domain: hostName.substring(hostName.indexOf('.'), hostName.length),
        });
        window.location.replace(
          `${accountList.get('login')}?redirect=${window.location.href}`
        );
      }
      if (urlResponse.data && urlResponse.data.downloadVideo) {
        sentGAEvent({
          category: 'Upload',
          action: 'URLSuccess',
          label: `${(
            urlResponse.data.downloadVideo.filesize /
            1024 /
            1024
          ).toFixed(2)}_${urlResponse.data.response_hostname}`,
        });
        this.setState({
          warningInfo: true,
          warningInfoText:
            'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ',
          warningInfoLinkText: 'download the video',
          warningInfoText2: 'and then use HitPaw Toolkit to proceed.',
          warningInfoObj: {
            type: 'urlSize',
            duration: urlResponse.data.downloadVideo.filesize,
          },
          fileObj: {
            videofileurl: urlResponse.data.downloadVideo.url,
            name: 'parseVideoByURL',
            format: urlResponse.data.downloadVideo.ext,
          },
        });
        this.setState({ visible: false });
        sentGAEvent({
          category: 'Upload',
          action: 'URLSizePopup',
          label: `${(
            urlResponse.data.downloadVideo.filesize /
            1024 /
            1024
          ).toFixed(2)}_${urlResponse.data.response_hostname[0]}`,
        });
        if (this.props.work === 'audioCut') {
          sentGAEvent({
            category: 'audio_cut_add_files',
            action: 'audio_cut_add_failed',
          });
        } else if (this.props.work === 'audioVolume') {
          sentGAEvent({
            category: 'audio_volume_add_files',
            action: 'audio_volume_add_failed',
          });
        } else if (this.props.work === 'audioSpeed') {
          sentGAEvent({
            category: 'audio_speed_add_files',
            action: 'audio_speed_add_failed',
          });
        }
        return false;
      }
      this.setState({ visible: false });
      message.warning(
        this.props.t('Sorry, error occurs when analyzing the URL.')
      );
      if (this.props.work === 'audioExtractor') {
        sentGAEvent({
          category: 'audio_extractor_add_files',
          action: 'audio_extractor_url_fail',
        });
      } else if (this.props.work === 'audioCut') {
        sentGAEvent({
          category: 'audio_cut_add_files',
          action: 'audio_cut_add_failed',
        });
      } else if (this.props.work === 'audioVolume') {
        sentGAEvent({
          category: 'audio_volume_add_files',
          action: 'audio_volume_add_failed',
        });
      } else if (this.props.work === 'audioSpeed') {
        sentGAEvent({
          category: 'audio_speed_add_files',
          action: 'audio_speed_add_failed',
        });
      } else {
        sentGAEvent({
          category: 'Upload',
          action: 'URLFail',
          label: urlResponse.msg,
        });
      }
    }
  };

  requestParseUrl = (url) => {
    const formData = new FormData();
    formData.append('token', this.props.tokenId);
    formData.append('url', url);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadUrl`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);
      xhr.onerror = () => {
        reject('parseUrl_' + xhr.status);
      };
      xhr.onabort = () => {
        console.log('ggg');
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
    });
  };

  clearUrl = () => {
    this.setState({ url: '' });
  };

  onUrlChange = (e) => {
    const url = e.target.value;
    this.setState({ url });
  };

  onCancel = () => {
    this.setState({ visible: false });
    const xhr = this.state.uploadXHR;
    if (xhr) {
      xhr.abort();
    } else {
      Utils.cancleProgress();
    }
  };

  componentDidMount() {
    this.clearUrl();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currFile !== this.props.currFile) {
      this.clearUrl();
    }
  }

  render() {
    return (
      <div>
        <AddFileByDragFunction
          parseUrl={this.parseUrl}
          onUrlChange={this.onUrlChange}
          visible={this.state.visible}
          fetchUrl={this.state.fetchUrl}
          onCancel={this.onCancel}
          url={this.state.url}
          theme={this.props.theme}
        />
        <TipsModal
          visible={this.state.warningInfo}
          onCancel={() => {
            this.setState({ warningInfo: false });
            this.clearUrl();
          }}
          content={this.state.warningInfoText}
          contentLink={this.state.warningInfoLinkText}
          content2={this.state.warningInfoText2}
          tipsObj={this.state.warningInfoObj}
          cancelBtnHandle={() => {
            this.setState({ warningInfo: false });
            this.clearUrl();
          }}
          hasDownload
          learnMoreHidden
          hasFileDownload
          fileObj={this.state.fileObj}
          checked
        />
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  tokenId: state.common.tokenId,
  files: state.files.files,
  currFile: state.files.currFile,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onFilesChange: (files) => dispatch(actions.onFilesChange(files)),
  onUploadingChange: (uploading) =>
    dispatch(actions.onUploadingChange(uploading)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onCurrFileChange: (currFile) => dispatch(actions.onCurrFileChange(currFile)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['upload'])(AddFileByUrl));
